import dateService from "../../../../../../common/utils/date/date.service";
import orderOptimizerTranslationsHelper from "../../../../../../languages/order-optimizer-translations.helper";
import { OrderOptimizerTaxiListingItemStatus } from "../../common/types/order-optimizer-taxi-listing-item";

const getDateLabel = (date: Date | null): string => {
  if (!date) {
    return "";
  }

  return dateService.formatDateTime(date);
};

const getScoreLabel = (score: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiListingTranslations().table;

  return `${translations.scoreLabel} ${score.toFixed() ?? "---"}`;
};

const getIdLabel = (id: number) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiListingTranslations().table;

  return `${translations.idLabel} ${id ?? "---"}`;
};

const getClassNameByStatus = (
  status: OrderOptimizerTaxiListingItemStatus,
): string => {
  switch (status) {
    case OrderOptimizerTaxiListingItemStatus.PENDING:
      return "pending";
    case OrderOptimizerTaxiListingItemStatus.INTERESTING:
      return "interesting";
    case OrderOptimizerTaxiListingItemStatus.REJECTED:
      return "rejected";
  }
};

const getStatusLabel = (
  status: OrderOptimizerTaxiListingItemStatus,
): string => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiListingTranslations().status;

  switch (status) {
    case OrderOptimizerTaxiListingItemStatus.INTERESTING:
      return translations.interesting;
    case OrderOptimizerTaxiListingItemStatus.PENDING:
      return translations.pending;
    case OrderOptimizerTaxiListingItemStatus.REJECTED:
      return translations.rejected;
  }
};

const getDelayLabel = (delaySeconds: number): string => {
  const hours = Math.floor(delaySeconds / 3600);
  const minutes = Math.floor((delaySeconds % 3600) / 60);

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0",
  )} h`;
};

const getDelayTitle = (delaySeconds: number): string => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyListingTranslations().table;

  return `${translations.orderDelayedLabel}: ${getDelayLabel(delaySeconds)}`;
};

const orderOptimizerTaxiListingTableRowHelper = {
  getDateLabel,
  getDelayTitle,
  getDelayLabel,
  getScoreLabel,
  getIdLabel,
  getClassNameByStatus,
  getStatusLabel,
};

export default orderOptimizerTaxiListingTableRowHelper;
